// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingsPageQueryVariables = Types.Exact<{
  filter: Types.ProductOfferingsFilter;
}>;


export type ProductOfferingsPageQuery = { __typename?: 'Query', productOfferings: { __typename?: 'ProductOfferingsPageResult', entities: Array<{ __typename?: 'ProductOffering', id: string, name: string, bidOutPercentage: number, activeElevationCount: number, copyInProgress: boolean, planPackage: { __typename?: 'PlanPackage', id: string, code?: string | null | undefined }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined, project?:
        | { __typename?: 'StandaloneProject', id: string }
        | { __typename?: 'Region', id: string }
        | { __typename?: 'Market', id: string }
        | { __typename?: 'Community', id: string }
        | { __typename?: 'Subdivision', id: string }
        | { __typename?: 'Lot', id: string }
        | { __typename?: 'Structure', id: string }
        | { __typename?: 'Unit', id: string }
       | null | undefined, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, availableUpdates: Array<{ __typename?: 'ProductOfferingIncomingUpdate', id: string, source:
          | { __typename?: 'Drop', id: string, name: string }
          | { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string, version?: number | null | undefined, readyPlan:
              | { __typename?: 'ReadyPlan', id: string, name: string }
              | { __typename?: 'PlanPackage', id: string, name: string }
              | { __typename?: 'DesignPackage', id: string, name: string }
              | { __typename?: 'ProductOffering', id: string, name: string }
             }
         }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } }> } };

export type ProductOfferingsDetailFragment = { __typename?: 'ProductOffering', id: string, name: string, bidOutPercentage: number, activeElevationCount: number, copyInProgress: boolean, planPackage: { __typename?: 'PlanPackage', id: string, code?: string | null | undefined }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined, project?:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
   | null | undefined, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined, minProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, availableUpdates: Array<{ __typename?: 'ProductOfferingIncomingUpdate', id: string, source:
      | { __typename?: 'Drop', id: string, name: string }
      | { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string, version?: number | null | undefined, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         }
     }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } };

export type ProductOfferingProgramDataFragment = { __typename?: 'ProgramData', id: string, depthInFeet?: number | null | undefined, widthInFeet?: number | null | undefined, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined };

export const ProductOfferingProgramDataFragmentDoc = gql`
    fragment ProductOfferingProgramData on ProgramData {
  id
  depthInFeet
  widthInFeet
  sellableSqft
  bedrooms
  fullBaths
  halfBaths
}
    `;
export const ProductOfferingsDetailFragmentDoc = gql`
    fragment ProductOfferingsDetail on ProductOffering {
  id
  name
  planPackage {
    id
    code
  }
  status: effectiveStatus {
    code
    name
  }
  development {
    id
  }
  project {
    id
  }
  coverAsset {
    id
    previewUrl(resizing: {width: 321, region: FULL})
  }
  minProgramData {
    ...ProductOfferingProgramData
  }
  maxProgramData {
    ...ProductOfferingProgramData
  }
  bidOutPercentage
  activeElevationCount
  copyInProgress
  availableUpdates {
    id
    source {
      ... on Drop {
        id
        name
      }
      ... on ReadyPlanAggregateVersion {
        id
        name
        version
        readyPlan {
          id
          name
        }
      }
    }
  }
  aggregateLatest {
    id
    displayVersion
  }
}
    ${ProductOfferingProgramDataFragmentDoc}`;
export const ProductOfferingsPageDocument = gql`
    query ProductOfferingsPage($filter: ProductOfferingsFilter!) {
  productOfferings(filter: $filter) {
    entities {
      ...ProductOfferingsDetail
    }
  }
}
    ${ProductOfferingsDetailFragmentDoc}`;

/**
 * __useProductOfferingsPageQuery__
 *
 * To run a query within a React component, call `useProductOfferingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductOfferingsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables> & ({ variables: ProductOfferingsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>(ProductOfferingsPageDocument, options);
      }
export function useProductOfferingsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>(ProductOfferingsPageDocument, options);
        }
// @ts-ignore
export function useProductOfferingsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>;
export function useProductOfferingsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingsPageQuery | undefined, ProductOfferingsPageQueryVariables>;
export function useProductOfferingsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>(ProductOfferingsPageDocument, options);
        }
export type ProductOfferingsPageQueryHookResult = ReturnType<typeof useProductOfferingsPageQuery>;
export type ProductOfferingsPageLazyQueryHookResult = ReturnType<typeof useProductOfferingsPageLazyQuery>;
export type ProductOfferingsPageSuspenseQueryHookResult = ReturnType<typeof useProductOfferingsPageSuspenseQuery>;
export type ProductOfferingsPageQueryResult = ApolloReactCommon.QueryResult<ProductOfferingsPageQuery, ProductOfferingsPageQueryVariables>;